<h2 mat-dialog-title>{{info.name}}</h2>
<mat-dialog-content>
    <center *ngIf="info.pic != null"><img style="width: 200px;" src="{{info.pic}}"/></center><br>
    {{info.info}}
    <br><br><br><center *ngIf="info.hint != null"><img src="{{info.hint}}"/></center>
</mat-dialog-content>
